import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class PasswordResetFinishService {
    private http = inject(HttpClient);

    save(keyAndPassword: any): Observable<any> {
        return this.http.post(
            environment.apiUrl + "api/account/reset-password/finish",
            keyAndPassword,
        );
    }

    checkKey(key: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}api/account/reset-password/${encodeURIComponent(key)}/check`,
        );
    }
}
